import { BarChart3, DollarSign, LineChart, Users } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const KPIS = [
  {
    icon: Users,
    title: "pawrld DAU/WAU/MAU",
    body: "Distinct-user counts pulled from ClickHouse events, broken down by referrer cohort.",
  },
  {
    icon: DollarSign,
    title: "Stripe revenue",
    body: "MRR, churn, paid-vs-trial split, refund volume. Fed by a daily snapshot job.",
  },
  {
    icon: LineChart,
    title: "Funnel + activation",
    body: "Signup → first action → second-day return, sliced by ad campaign UTM.",
  },
];

export default function Biz() {
  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-center gap-3">
        <div className="grid h-10 w-10 place-items-center rounded-md bg-muted text-muted-foreground">
          <BarChart3 className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-xl font-semibold">Biz</h1>
          <p className="text-sm text-muted-foreground">
            The numbers that matter. Coming in v3, fed by the telemetry pipeline.
          </p>
        </div>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {KPIS.map((k) => (
          <Card key={k.title}>
            <CardHeader>
              <div className="flex items-center gap-2">
                <k.icon className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                <CardTitle>{k.title}</CardTitle>
              </div>
              <CardDescription>v3</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">{k.body}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Source of truth</CardTitle>
          <CardDescription>
            Once <code className="font-mono text-xs">telemetry-relay</code> is
            live, every chart on this page queries ClickHouse Cloud (the{" "}
            <code className="font-mono text-xs">events</code> table). Stripe
            data comes from a nightly export into the same warehouse.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
